if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {
    constructor() {
      super();

      this.bindOnScroll = this.onScroll.bind(this);
      this.bindOnClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.footer = document.querySelector('.footer');
      this.hideOnFooter = this.hasAttribute('hide-on-footer');
      this.elementTrigger = this.dataset.elementTrigger;
      this.button = this.querySelector('button');

      if (this.button) {
        this.button.addEventListener('click', this.bindOnClick);
      }

      if (this.footer && this.hideOnFooter) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.classList.toggle('hide', entry.isIntersecting);
        })

        this.observer.observe(this.footer);
      }

      if (this.elementTrigger != '' || this.elementTrigger != null) {
        this.trigger = document.querySelector(this.elementTrigger);
        if (this.trigger) {
          window.addEventListener('scroll', this.bindOnScroll);
        }
      }
    }

    disconnectedCallback() {
      if (this.observer && this.footer) this.observer.unobserve(this.footer);
      if (this.trigger) window.removeEventListener('scroll', this.bindOnScroll);
    }

    onScroll() {
      this.classList.toggle('above-trigger', this.trigger.getBoundingClientRect().top > 0);
    }

    onClick() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  customElements.define('back-to-top', BackToTop)
}